// @flow

import {
  ORGANIZATIONS_REQUEST,
  ORGANIZATIONS_SUCCESS,
  ORGANIZATIONS_ERROR
} from '../actions/organizations';

type State = {
  data: Array<any>,
  loading: boolean,
  error: ?string
};

const initialState: State = {
  data: [],
  loading: false,
  error: null
};

function organizationsReducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case ORGANIZATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };

    case ORGANIZATIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}

export default organizationsReducer;



// WEBPACK FOOTER //
// ./src/reducers/organizations.js